import {componentsLoader} from '@wix/document-services-implementation'

export default function () {
    return {
        asyncInitMethod: componentsLoader.loadExternalComponentsForDS,
        methods: {}
    }
}
